jQuery('.info-cards #infoCardsSlider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<svg class="slick-arrow slick-prev" xmlns="http://www.w3.org/2000/svg" width="44.839" height="44.337" viewBox="0 0 44.839 44.337"><g id="Group_5" data-name="Group 5" transform="translate(1853 4392.631) rotate(180)"><g id="Subtraction_27" data-name="Subtraction 27" transform="translate(1808.161 4348.294)" fill="#eb2932"><path d="M 43.83901977539062 43.337158203125 L 0.9999998807907104 43.337158203125 L 0.9999998807907104 0.9999991059303284 L 43.83901977539062 0.9999991059303284 L 43.83901977539062 43.337158203125 Z" stroke="none"/><path d="M 2 2 L 2 42.337158203125 L 42.83901977539062 42.337158203125 L 42.83901977539062 2 L 2 2 M 0 0 L 44.83901977539062 0 L 44.83901977539062 44.337158203125 L 0 44.337158203125 L 0 0 Z" stroke="none" fill="#eb2932"/></g><path id="Path_31" data-name="Path 31" d="M1807.094,4434.038l9.029,9.03-9.029,9.029" transform="translate(18.972 -72.604)" fill="none" stroke="#fff" stroke-width="3"/></g></svg>',
    nextArrow: '<svg class="slick-arrow slick-next" xmlns="http://www.w3.org/2000/svg" width="44.839" height="44.337" viewBox="0 0 44.839 44.337"><g id="Group_4" data-name="Group 4" transform="translate(-1808.161 -4348.294)"><g id="Subtraction_27" data-name="Subtraction 27" transform="translate(1808.161 4348.294)" fill="#eb2932"><path d="M 43.83901977539062 43.337158203125 L 0.9999998807907104 43.337158203125 L 0.9999998807907104 0.9999991059303284 L 43.83901977539062 0.9999991059303284 L 43.83901977539062 43.337158203125 Z" stroke="none"/><path d="M 2 2 L 2 42.337158203125 L 42.83901977539062 42.337158203125 L 42.83901977539062 2 L 2 2 M 0 0 L 44.83901977539062 0 L 44.83901977539062 44.337158203125 L 0 44.337158203125 L 0 0 Z" stroke="none" fill="#eb2932"/></g><path id="Path_31" data-name="Path 31" d="M1807.094,4434.038l9.029,9.03-9.029,9.029" transform="translate(18.972 -72.604)" fill="none" stroke="#fff" stroke-width="3"/></g></svg>',
    autoplay: true,
    autoplaySpeed: 4000,
    rows: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 501,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});
